import { defineComponent } from 'vue';
import AccountManager from '@/presentation/components/campaign-management/account-manager/account-manager.vue';
import ClientServicesPerson from '@/presentation/components/campaign-management/client-services-person/client-services-person.vue';
import CrmRegionWrapper from '@/presentation/components/campaign-management/crm-region-wrapper/crm-region-wrapper.vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import CampaignManagementCode from '@/presentation/components/campaign-management/campaign-management.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		AccountManager,
		ClientServicesPerson,
		CrmRegionWrapper
	},
	setup: () => {
		const code = new CampaignManagementCode();

		return {
			isLoading: code.isLoading
		};
	}
});
